module.exports = __webpack_public_path__ + "static/media/contextual-help-alert.f0ecb466.png";